import { showError } from '@calendly/alert'
import { httpRequest } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { isEmpty } from 'lodash-es'

import { unableToChangeTierSelector } from '../selectors'
import { showContactSupportModal } from './contact_support'

const fetchNewPlan = (billingInfo, billingAction) => {
  if (billingAction === 'upgrade_frequency') {
    const {
      actions: {
        change_frequency:
          { upgrade_plans: [newPlan] }
      }
    } = billingInfo
    return newPlan
  }

  // destructuring below is not robust in returing null
  // if actions.change_tier is an empty object
  if (isEmpty(billingInfo.actions.change_tier)) {
    return null
  }

  const {
    actions: {
      change_tier:
        { upgrade_plans: [newPlan] }
    }
  } = billingInfo
  return newPlan
}

export const fetchBillingInfo = createAsyncThunk(
  'billingInfo/fetch',
  async (params, { dispatch, getState }) => {
    const {
      billingAction,
      currentTier
    } = params
    const unableToChangeTier = unableToChangeTierSelector(getState())

    if (unableToChangeTier) {
      const localizedTier = I18n.t(`publisher.billing.tiers.${currentTier}`)
      dispatch(showContactSupportModal(localizedTier))
      return true
    }

    const [success, billingInfo] = await httpRequest({
      url: '/api/billing/info'
    })

    if (!success) {
      dispatch(showError(I18n.t('publisher.billing.failure.billing_info')))
    }

    if (isEmpty(billingInfo.actions.change_tier.upgrade_plans) && billingAction === 'upgrade_tier') {
      const localizedTier = I18n.t(`publisher.billing.tiers.${billingInfo.tier}`)
      dispatch(showContactSupportModal(localizedTier))
      return true
    }
    const newPlan = fetchNewPlan(billingInfo, billingAction)

    return {
      oldPlan: billingInfo.subscription.plan,
      subscription: billingInfo.subscription,
      newPlan
    }
  }
)
